///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'sui-pagination[windeGridPagination]',
    standalone: false
})
export class GirdPaginationDirective {
    @HostBinding('class') buttonClass = 'winde-grid-pagination';
}
